import React from "react";

import "./Shares.scss"
import { isMobile, isIos } from "../../static/helper";
import { GA_Event } from "../Analytics/Analytics";

function Shares(props) {
  const shareUrl = 'https://z.ynet.co.il/mShort/content/2020/gamesparade/';

  const shareFacebook = (e) => {
    e.stopPropagation();
    window.open("https://www.facebook.com/share.php?u=" + shareUrl, '_blank', "width=500,height=300");
    GA_Event('Share_Events', 'Social', `Share From ${props.location ? props.location : "Site Head"}`, "Facebook");
    
  }

  const shareWhatsapp = (e) => {
    e.stopPropagation();
    let url = '';
    if (isMobile() || isIos()) {
      url = `whatsapp://send?text=${shareUrl}`;
      window.open(url, "_parent");
    } else {
      url = `https://api.whatsapp.com/send?phone=&text=${shareUrl}`
      window.open(url, "_blank");
    }
    GA_Event('Share_Events', 'Social', `Share From ${props.location ? props.location : "Site Head"}`, "Whatsapp");
    // let url = `whatsapp://send?text=${shareUrl}`;
    // window.open(url, '_blank', "width=500,height=300");
    // this.props.sendGA("Share_Whatsapp", url);
  }

  const shareTwitter = (e) => {
    e.stopPropagation();
    let title = "שם המשחק - ynet";
    let description = 'מ-FIFA ועד מיינקראפט, מה-Sims ועד מורטל קומבט: הגיע הזמן להכריע אחת ולתמיד – מהו משחק הווידאו הטוב ביותר בכל הזמנים?';
    let url = 'https://twitter.com/intent/tweet?text=' + title + " " + description + "%0A" + shareUrl;
    window.open(url, '_blank', "width=500,height=300");
    GA_Event('Share_Events', 'Social', `Share From ${props.location ? props.location : "Site Head"}`, "Twitter");
  }

  return (
    <div className="shares-container">
      <div className="whatsapp" onClick={shareWhatsapp}></div>
      <div className="twitter" onClick={shareTwitter}></div>
      <div className="facebook" onClick={shareFacebook}></div>
    </div>
  );
}

export default Shares;
